<template>
  <zj-layout-container v-loading="loading"  :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">抓拍设备</div>
      <el-input v-model="DeviceNmae"  placeholder="请输入设备名称" class="nav-tree-filter"></el-input>
      <el-tree
        :data="devicedata"
        default-expand-all
        :filter-node-method="filterNode"
        @node-click="nodeClick"
        ref="devicetree"
        node-key="id"
        class="zj-demo-player-tree-device-tree">
      </el-tree>
    </zj-layout-header>
    <zj-layout-main></zj-layout-main>
  </zj-layout-container>
</template>
<script>

import DeviceApis from "../../../../../monitor/src/apis";

export default {
  name: "FaceCamera",
  controller: "UI",
  action: "FaceCamera",
  props: {
      OnTreeSelected: {
        type: Function,
        default: null
      }
    },
  data(){
    return{
        DeviceNmae:"",
        loading: false,
        loadingText: "加载中...",
        devicedata:[],
        checkedKey:[]
    }
  },
  created(){
    this.search();
  },
  watch:{
     DeviceNmae(val){
        this.$refs.devicetree.filter(val);
     }
  },
  methods:{
       filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
    search() {
      let that = this;
      this.loading=true;
      new DeviceApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
          DeviceType:"SubSystem.Monitor.EquipmentType.CaptureMonitor"
        })
        .then((r) => {
          r = r.data.Data;
           this.loading=false;
          //console.log(r);
          this.devicedata = that.convertToTreeNodesfunction(r);
        })
        .catch((e) => {
          console.error(e);
           this.loading=false;
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索抓拍设备失败！",
            type: "error",
          });
        });
    },
   convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          IndexCode:this.GetIndexCode(regionData.JsonExtend),
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];       
          region.children.push({
            id: deviceData.DeviceId,
            IndexCode:this.GetIndexCode(deviceData.JsonExtend),
            label: deviceData.DeviceName,
            children: [],
            });        
        }
        if(region.children.length>0){
           result.push(region);
        }
      }
      return result;
    },
    GetIndexCode(JsonExtend){
     if(JsonExtend){
    
        var camerinfo=JSON.parse(JsonExtend);
        if(camerinfo){
        return camerinfo.IndexCode;}
        else{
        return "";}
     }
     else{
       return "";
     }
    },
   nodeClick: function(data) {   
       if(this.OnTreeSelected)
        this.OnTreeSelected(data);
    },
  }
}

</script>